import { render, staticRenderFns } from "./9c_doc.vue?vue&type=template&id=45df642d&scoped=true"
import script from "./9c_doc.vue?vue&type=script&lang=js"
export * from "./9c_doc.vue?vue&type=script&lang=js"
import style0 from "./9c_doc.vue?vue&type=style&index=0&id=45df642d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45df642d",
  null
  
)

export default component.exports